import React, { useCallback, useEffect, useRef, useState } from "react";
import SelectForm from "../../../components/ComponentesFormularios/SelectForm";
import InputForm from "../../../components/ComponentesFormularios/InputForm";
import { Colors } from "../../../assets/colors/Colors";
import Tooltip from "@mui/material/Tooltip";
import RadioButtonForm from "../../../components/ComponentesFormularios/RadioButtonForm";
import { CalendarForm, CalendarFormRange } from "../../../components/ComponentesFormularios/CalendarForm";
import { modalCRUDService } from "../../../services/modalCRUDService";
import { GlobalConstants } from "../../../data/GlobalConstants";
import { useDispatch, useSelector } from "react-redux";
import {
    convertToString,
    dateToStringFormat, getDateTime,
    getFechaToCalendarRange,
    validarEspaciosEnBlanco
} from "../../../util/functions";
import { FormProvider, useForm, useFormContext, useWatch } from "react-hook-form";
import { isEmpty, isObject } from "../../../util/is";
import SelectFormVirtualize from "../../../components/ComponentesFormularios/SelectFormVirtualize";
import {
    classResponsiveForm,
    classResponsiveFormDoubleWidth, classResponsiveFormWidthHeader, ERRORFIELDREQUIRED,
    optionsEstados
} from "../../../data/ConstantForm";
import NestedSelectVirtualizeForm from "../../../components/ComponentesFormularios/NestedSelectVirtualizeForm";
import { vehiculosService } from "src/services/apiVehiculos";


const DatosBasicos = React.memo(({ isEditing, isAddMode, properties, stateSelects }) => {

    const { control, formState: { errors } } = useFormContext();


    return (
        <div className="container mx-0 px-0 w-100 mw-100">

            <div className="row mx-0 px-0 mt-3 mb-2">

                <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="agenteComercial" label="Agente Comercial"
                    options={stateSelects?.arrAgentesComerciales} required={true} className={`${classResponsiveFormWidthHeader}`} readOnly={false}
                    customError={errors.agenteComercial ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} identificador="placa" label="Placa" disabled={!isAddMode ? true : false} readOnly={!isEditing}
                    placeholder="Longitud max 6" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.placa ? 'No se acptan guiones' : null} rules={{ minLength: 6, maxLength: 6, pattern: { value: /^[a-zA-Z0-9]*$/ } }} />

                <SelectFormVirtualize inputProps={{ control }} disabled={!isEditing} identificador="tipoVehiculos" label="Tipo Vehículos"
                    options={stateSelects?.arrClasesVehiculos} required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.tipoVehiculos ? ERRORFIELDREQUIRED : null} />

                <CalendarForm inputProps={{ control }} disabled={true} identificador="dtCreacion" label="Fecha Creación"
                    required={true} className={`${classResponsiveFormWidthHeader}`} customError={errors.dtIngreso ? ERRORFIELDREQUIRED : null} />

            </div>

            <div className="row mx-0 px-0 mt-3 mb-2">

                <InputForm inputProps={{ control }} identificador="modelo" label="Modelo" readOnly={!isEditing}
                    placeholder="Ej: 2000" required={true} type="number" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.modelo ? ERRORFIELDREQUIRED : null} rules={{ minLength: 4, maxLength: 5 }} />

                <InputForm inputProps={{ control }} identificador="docResponsable" label="Documento" readOnly={!isEditing}
                    placeholder="Ej: 1000345334" required={true} type="number" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.docResponsable ? ERRORFIELDREQUIRED : null} rules={{ minLength: 7, maxLength: 15 }} />

                <InputForm inputProps={{ control }} identificador="responsable" label="Responsable" readOnly={!isEditing}
                    placeholder="Ej: Juan Perez" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.responsable ? ERRORFIELDREQUIRED : null} />

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="celular" label="Celular"
                    placeholder="Ej: 3002467589" type="number" required={true} className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.celular ? "Longitud min 10 y max 11" : null} rules={{ minLength: 10, maxLength: 11 }} />

            </div>
            <div className="row mx-0 px-0 mt-3 mb-2">

                <InputForm inputProps={{ control }} disabled={!isEditing} identificador="correo" label="Correo"
                    placeholder="Ej: prueba@correo.co" required={true} type="text" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.correo ? ERRORFIELDREQUIRED : null} rules={{pattern: { value: /\S+@\S+\.\S+/}}} />

                <RadioButtonForm inputProps={{ control }} disabled={!isEditing} identificador="estado" options={optionsEstados} required={true}
                    defaultValue="1" label="Estado" className={`${classResponsiveFormWidthHeader}`}
                    customError={errors.estado ? ERRORFIELDREQUIRED : null} />
            </div>

        </div>
    )
})

const FormVehiculosCRUD = ({ isEditing, properties, isAddMode }) => {

    const { data, params, tableRef } = properties;
    const dispatch = useDispatch();
    const authState = useSelector(state => state.auth)
    const { idUsuario } = authState;
    const generalServicesState = useSelector(state => state.generalServices)
    const methods = useForm({
        defaultValues: {
            ...data
        }
    });
    const { register, handleSubmit, formState: { errors }, control } = methods;

    const onSuccessSubmit = data => {

        data.idUsrAuditoria = idUsuario;
        data.ac = isAddMode && isEditing ? 'C' : isEditing ? 'A' : 'LOCK';

        vehiculosService.crudVehiculos(data).then(
            response => {

                const { status, msg, data: datos } = response;

                if (status) {
                    if (datos?.idmsg === 200) {

                        if (isAddMode) {
                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            tableRef.current.api.applyTransaction({
                                add: [{
                                    id: datos?.idreg,
                                    estado: data.estado,
                                    agenteComercial: data.agenteComercial.text,
                                    responsable: data.docResponsable,
                                    nombre: data.responsable,
                                    celular: data.celular,
                                    id: data.placa,
                                    vehiculo: data.tipoVehiculos.text
                                }]
                            })
                        }
                        else {

                            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess, message: datos?.txmsg } });

                            const rowNode = params.api.getRowNode(params.node.id);
                            const agente = rowNode.data.agenteComercial
                            const tipoVehiculo = rowNode.data.vehiculo

                            rowNode.setDataValue("estado", data?.estado);
                            rowNode.setDataValue("agenteComercial", isObject(data.agenteComercial) ? data.agenteComercial.text : agente);
                            rowNode.setDataValue("responsable", data.docResponsable);
                            rowNode.setDataValue("nombre", data?.responsable);
                            rowNode.setDataValue("celular", data?.celular);
                            rowNode.setDataValue("id", data?.placa);
                            rowNode.setDataValue("vehiculo", isObject(data.tipoVehiculos) ? data.tipoVehiculos.text : tipoVehiculo);
                        }

                        modalCRUDService.clear();
                    }
                    else {
                        dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: datos?.txmsg } });
                    }

                } else {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: msg } });
                }

            },
            error => {
                dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError, message: error.toString() } });
            }
        );
    }

    const onErrorSubmit = errors => {
        console.log(errors)
    }

    return (
        <FormProvider {...methods} >
                <header className="px-4 d-flex align-items-center mw-100 mt-2 justify-content-between">

                    <div className="row px-4">
                    </div>

                    <div className="d-flex justify-content-end align-items-center">
                        {isEditing &&
                            <Tooltip title="Guardar" aria-label="guardar">
                                <a onClick={handleSubmit(onSuccessSubmit, onErrorSubmit)}
                                    className="icon-container-actions d-flex">
                                    <div style={{ backgroundColor: Colors.COLOR_GREEN_DARK }} />
                                    <i style={{ color: Colors.COLOR_GREEN_DARK }} className="fas fa-check fa-2x" />
                                </a>
                            </Tooltip>
                        }
                        <Tooltip title="Cancelar" aria-label="cancelar">
                            <a onClick={() => { modalCRUDService.clear() }} className="icon-container-actions d-flex">
                                <div style={{ backgroundColor: Colors.RED_SWITCH_INACTIVE }} />
                                <i style={{ color: Colors.RED_SWITCH_INACTIVE }} className="fas fa-times fa-2x" />
                            </a>
                        </Tooltip>
                    </div>

                </header>
                <DatosBasicos isEditing={isEditing} properties={properties} stateSelects={generalServicesState} isAddMode={isAddMode} />
        </FormProvider>
    )

}

export default FormVehiculosCRUD;
